export interface SurplusLinesOpportunityModel {
    CompassId: number,
    InsuredId: number,
    OwnerId: number,
    SponsorId: number,
    SponsorName: string,
    SponsorType: string,
    Role: string,
    Type: string,
    Code: string,
    Status: string,
    ExpirationDate: string,
    Order: string,
    DeclinedReason: string
}

export interface SurplusLinesOpportunityDetailModel extends SurplusLinesOpportunity {
    Title: string,
    LogoURI: string,
    HasPolicyDoc: boolean,
    HasPolicySpecimen: boolean,
    HasCustomDoc: boolean,
    RequireExistingCoverages: boolean,
    CustomDocTitle: string,
    ContentHTML: string,
}

export class SurplusLinesOpportunityDetail implements SurplusLinesOpportunityDetailModel {
    CompassId: number = 0;
    CompassPassword: string = '';
    InsuredId: number = 0;
    OwnerId: number = 0;
    SponsorId: number = 0;
    SponsorName: string = '';
    SponsorType: string = '';
    Role: string = '';
    Type: string = '';
    Code: string = '';
    Status: string = '';
    ExpirationDate: string = '';
    Order: string = '';
    DeclinedReason: string = '';
    Title: string = '';
    LogoURI: string = '';
    HasPolicyDoc: boolean = false;
    HasPolicySpecimen: boolean = false;
    HasCustomDoc: boolean = false;
    RequireExistingCoverages: boolean = false;
    CustomDocTitle: string = '';
    ContentHTML: string = '';
}

export class SurplusLinesOpportunity implements SurplusLinesOpportunityModel {
    CompassId: number = 0;
    CompassPassword: string = "";
    InsuredId: number = 0;
    OwnerId: number = 0;
    SponsorId: number = 0;
    SponsorName: string = '';
    SponsorType: string = '';
    Role: string = '';
    Type: string = '';
    Code: string = '';
    Status: string = '';
    ExpirationDate: string = '';
    Order: string = '';
    DeclinedReason: string = '';
}

export interface CompassQuoteOptionsModel {
    COLADurationDefault: string,
    COLADurationOptions: string,
    DurationDefault: string,
    DurationOptions: string,
    EEBDurationDefault: string,
    EEBDurationOptions: string,
    EPDefault: string,
    EPOptions: string,
    ID: string,
    IDRDurationDefault: string,
    IDRDurationOptions: string,
    Increment: string,
    Message: string,
    MinBenefit: string,
    Name: string,
    PLPAmountDefault: string,
    PLPAmountOptions: string,
    PLPDurationDefault: string,
    PLPDurationOptions: string,
    RCBAmountDefault: string,
    RCBAmountOptions: string,
    RCBDurationDefault: string,
    RCBDurationOptions: string,
    SLRAmountDefault: string,
    SLRAmountOptions: string,
    SLRDurationDefault: string,
    SLRDurationOptions: string,
    Status: string,
    TTDMonthlyBenefit: string,
    COLAInclusion: string,
    IDRInclusion: string,
    EEBInclusion: string,
    SLRInclusion: string,
    PLPInclusion: string,
    RCBInclusion: string
}

export class CompassQuoteOptions implements CompassQuoteOptionsModel {
    COLADurationDefault: string = '';
    COLADurationOptions: string = '';
    DurationDefault: string = '';
    DurationOptions: string = '';
    EEBDurationDefault: string = '';
    EEBDurationOptions: string = '';
    EPDefault: string = '';
    EPOptions: string = '';
    ID: string = '';
    IDRDurationDefault: string = '';
    IDRDurationOptions: string = '';
    Increment: string = '';
    Message: string = '';
    MinBenefit: string = '';
    Name: string = '';
    PLPAmountDefault: string = '';
    PLPAmountOptions: string = '';
    PLPDurationDefault: string = '';
    PLPDurationOptions: string = '';
    RCBAmountDefault: string = '';
    RCBAmountOptions: string = '';
    RCBDurationDefault: string = '';
    RCBDurationOptions: string = '';
    SLRAmountDefault: string = '';
    SLRAmountOptions: string = '';
    SLRDurationDefault: string = '';
    SLRDurationOptions: string = '';
    Status: string = '';
    TTDMonthlyBenefit: string = '';
    COLAInclusion: string = '';
    IDRInclusion: string = '';
    EEBInclusion: string = '';
    SLRInclusion: string = '';
    PLPInclusion: string = '';
    RCBInclusion: string = '';
}

export class EmailCodeResult {
    EmailCode: string = '';
    Created: string = '';

}